import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { EmailProvider } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/email-provider" component={EmailProvider} />
);

export default routes;


// WEBPACK FOOTER //
// src/modules/screens/settings/EmailProvider/routes.js